import { apiDelete, apiGet, apiPost, apiPut } from './api-service';
import { getUserDetails } from './session-service';

export async function getAll() {
    try {
        const response = await apiGet('core', `consultant`);

        return response;
    } catch (e) { }
}


export async function getConsultant(id?: string) {
    try {
        if (!id) {
            id = getUserDetails().consultant_id;
        }
        const response = await apiGet('core', `consultant/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}

export async function consultantAdd(consultantBody: any) {
    try {
        const response = await apiPost('core', 'consultant', consultantBody);
        return response;
    } catch (e) { }
}

export async function consultantUpdate(consultantBody: any, id?: string) {
    try {
        if (!id) {
            id = getUserDetails().consultant_id;
        }
        const response = await apiPut('core', `consultant/${id}`, consultantBody);

        return response;
    } catch (e) { }
}

export async function consultantRemove(id: any) {
    try {

        return await apiDelete('core', `consultant/${id}`);

    } catch (e) { }
}

export async function SacpcmpLookup(id: string): Promise<any> {
    try {
        const response = await apiPost('core', `sacpcmpLookup`, {
            sacpcmp_id: id
        });

        console.log(response);
        return (response as any).content;
    } catch (e) {
        console.log('POST call failed: ', e);
    }
}